import * as Yup from 'yup'

export const initialValues = {
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    location: '',
    description: '',
}

export const contactSchema = Yup.object().shape({
    first_name: Yup.string()
        .required('Required')
        .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
    last_name: Yup.string()
        .required('Required')
        .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
    email: Yup.string().email('Invalid email').required('Required'),
    phone: Yup.string().min(15, 'Invalid phone number').required('Required'),
    location: Yup.string().required('Required'),
    description: Yup.string(),
})
